<template>
  <div class="container mt-4">
    <div class="row g-3">
      <!-- Grade Dropdown -->
      <div class="col-12 col-sm-6 col-lg-4">
        <select
          v-model="selectedGrade"
          @change="onGradeChange"
          class="form-select form-select-sm"
        >
          <option value="">Grade</option>
          <option v-for="grade in grades" :key="grade.id" :value="grade.id">
            {{ grade.level }}
          </option>
        </select>
      </div>
      <!-- Subject Dropdown -->
      <div class="col-12 col-sm-6 col-lg-4">
        <select
          v-model="selectedSubject"
          @change="onSubjectChange"
          class="form-select form-select-sm"
          :disabled="!selectedGrade"
        >
          <option value="">Subject</option>
          <option
            v-for="subject in subjects"
            :key="subject.id"
            :value="subject.id"
          >
            {{ subject.name }}
          </option>
        </select>
      </div>

      <!-- Topic Dropdown -->
      <div class="col-12 col-sm-6 col-lg-4">
        <select
          v-model="selectedTopic"
          @change="onTopicChange"
          class="form-select form-select-sm"
          :disabled="!selectedSubject"
        >
          <option value="">Topic</option>
          <option v-for="topic in topics" :key="topic.id" :value="topic.id">
            {{ topic.title }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "DropdownItem",

  data() {
    return {
      grades: [],
      subjects: [],
      topics: [],

      selectedGrade: "",
      selectedSubject: "",
      selectedTopic: "",
    };
  },

  async mounted() {
    await this.fetchGrades();
  },

  methods: {
    async fetchGrades() {
      const studentId = localStorage.getItem("userId");
      const res = await axios.get(`/student-grades/${studentId}`);
      this.grades = res.data || [];
    },

    async onGradeChange() {
      this.selectedSubject = "";
      this.selectedTopic = "";
      this.topics = [];
      if (!this.selectedGrade) return;

      const studentId = localStorage.getItem("userId");
      const res = await axios.get(
        `/student-subjects/${studentId}/${this.selectedGrade}`,
      );
      this.subjects = res.data || [];
    },

    async onSubjectChange() {
      this.selectedTopic = "";
      if (!this.selectedSubject) return;

      const studentId = localStorage.getItem("userId");
      const res = await axios.get(
        `/student-topics/${studentId}/${this.selectedGrade}/${this.selectedSubject}`,
      );
      this.topics = res.data || [];
    },

    onTopicChange() {
      this.$emit("topic-selected", this.selectedTopic || null);
    },
  },
};
</script>

<style scoped>
.form-select-sm {
  border: 2px solid #ff00cc;
  border-radius: 6px;
  min-width: 120px;
}
.form-select-sm:disabled {
  background-color: #f8f9fa;
}
</style>
